export const titleize = (string: string | undefined | null) => {
  if (!string) return '';
  return string
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
};
